import { createFileRoute } from "@tanstack/react-router";
import { LivePricesPage } from "@/pages/live-prices";
import { head, loader } from "@/pages/live-prices.meta";

export const Route = createFileRoute("/$locale/live-prices")({
  loader,
  head,
  component: LivePricesPage,
});
